(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-contact"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".contact-fab").forEach(function (fab) {
    var mainBtn = fab.querySelector(".contact-fab__main");

    if (!mainBtn) return;

    function closeProductSubscribeChat() {
      var chat = document.getElementById("product-subscribe-chat");

      if (!chat) return;

      chat.classList.remove("is-active");
      chat.setAttribute("aria-hidden", "true");
    }

    function openProductSubscribeChat() {
  var chat = document.getElementById("product-subscribe-chat");

  if (!chat) return;

  chat.classList.add("is-active");
  chat.setAttribute("aria-hidden", "false");
}

    mainBtn.addEventListener("click", function (e) {
  e.stopPropagation();

  fab.dataset.open = fab.dataset.open === "true" ? "false" : "true";

  if (fab.dataset.open === "true") {
    document.body.classList.add("contact-fab-open");
    openProductSubscribeChat();
  } else {
    document.body.classList.remove("contact-fab-open");
    closeProductSubscribeChat();
  }
});

    document.addEventListener("click", function () {
  fab.dataset.open = "false";
  document.body.classList.remove("contact-fab-open");
  closeProductSubscribeChat();
});
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
